module.exports = __webpack_public_path__ + "img/om.c1b06fb0.svg";